e.N.homework_tracker = {
	assignment_container : {},
	sort_assignments : {},

	init : function(){
		var $widget = $( '.homework-tracker-widget' );
		this.sort_assignments = $widget.find( '#sort-assignment-by a' );
		this.assignment_container = $widget.find( '.homework-list' );

		this.sort_assignments.on( 'click', this._sort_assignments );
	},


	_sort_assignments : function(){

		var $clicked = $( this );
		var self = e.N.homework_tracker;

		self.sort_assignments.removeClass( 'active' );
		$clicked.addClass( 'active' );

		var $sort_by = $clicked.data( 'by' );

		var $ass = self.assignment_container.find( 'li' );
		$ass.slideUp();
		$ass.sort( function( a, b ){
			return a.getAttribute( 'data-' + $sort_by ) - b.getAttribute( 'data-' + $sort_by );
		} ).appendTo( self.assignment_container );
		$ass.slideDown();

	}


};
